
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


import * as klaro from 'klaro'
import getBugsnagClient from './bugsnag';
import AsyncComputed from 'vue-async-computed';
import * as VueGoogleMaps from 'vue2-google-maps';

import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css'
import 'sweetalert2/src/sweetalert2.scss';

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
window.$ = window.jQuery = require('jquery');
window.Vue = require('vue').default;
// we define a minimal configuration
const config = {
    privacyPolicy: 'https://apag.de/datenschutz',
    acceptAll: true,
    hideDeclineAll: false,
    mustConsent: true,
    lang: 'de',
    translations: {
        de: {
            consentModal: {
                title: "Cookies auf meine.apag.de",
            },
            googleMaps: {
                title: "Google Maps",
                description: "Der Dienst Google Maps ermöglicht uns die Darstellung von Standorten auf einer interaktiven Karte. Da bei der Einbindung Daten an Google übertragen werden, müssen Sie der Verwendung zuvor zustimmen. Deaktivieren Sie diesen Dienst, um die Einbindung von Google Maps zu untersagen. Es gilt die Google-Datenschutzerklärung.",
            },
            bugsnag: {
                title: "Bugsnag",
                description: "Bugsnag ist ein Dienst, mit dem Programmfehler, bspw. Abstürze der von uns angebotenen Dienste, an uns gemeldet und von uns analysiert werden können. Diese Daten werden auf den Servern von Bugsnag (USA) gespeichert."
            },
            notwendig: {
                title: "Notwendig",
                description: "Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Webseite ermöglichen. Die Webseite kann ohne diese Cookies nicht richtig funktionieren."
            },
            purposes: {
                maps: "Kartenansicht",
                notwendig: "Funktionalität",
                error: "Fehleranalyse"
            }
        }
    },
    services: [
        {
            name: "notwendig",
            purposes: ["notwendig"],
            required: true,
        },
        {
            name: "googleMaps",
            purposes: ["maps"],
        },
        {
            name: "bugsnag",
            purposes: ["error"],
        },
    ],
};
window.klaro = klaro;
window.config = config;

const cm = klaro.getManager(config);
if(!cm.confirmed) {
    klaro.show(config, true);
}
const confirmed = cm.getConsent('bugsnag');
if(confirmed) {
    const bugsnagClient = getBugsnagClient();
    bugsnagClient.getPlugin('vue').installVueErrorHandler(window.Vue);
}
cm.watch({
    update(obj, name, data) {
        if(obj.states.bugsnag) {
            const bugsnagClient = getBugsnagClient();
            bugsnagClient.getPlugin('vue').installVueErrorHandler(window.Vue);
        }
    }
})

Vue.use(AsyncComputed)
Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyC3rjTz2DuSoWYMv2bgtmOAmDJeyjRIzyQ',
    },
    installComponents: true
});
Vue.use(FloatingVue, {
    themes: {
      'info-tooltip': {
        $extend: 'tooltip',

      },
    },
  })
// const VTooltip = require('v-tooltip');
// Vue.use(VTooltip);
Vue.component(
    'fieldExtrainput',
    () => import(
        /* webpackChunkName: "custom-input" */
        './components/kundenantrag/ExtraInput.vue'
    )
);
Vue.component(
    'fieldDateinput',
    () => import(
        /* webpackChunkName: "custom-input" */
        './components/kundenantrag/DateInput.vue'
    )
);
Vue.component(
    'fieldCustomertypeinput',
    () => import(
        /* webpackChunkName: "custom-input" */
        './components/kundenantrag/CustomerTypeInput.vue'
    )
);
Vue.component(
    'fieldMediuminput',
    () => import(
        /* webpackChunkName: "medium-input" */
        './components/kundenantrag/MediumInput.vue'
    )
);
Vue.component(
    'fieldTarifinput',
    () => import(
        /* webpackChunkName: "tarif-input" */
        './components/kundenantrag/TarifInput.vue'
    )
);
Vue.component(
    'fieldParkobjectinput',
    () => import(
        /* webpackChunkName: "parkobject-input" */
        './components/kundenantrag/ParkobjectInput.vue'
    )
);
Vue.component(
    'fieldContactinput',
    () => import(
        /* webpackChunkName: "contact-input" */
        './components/kundenantrag/ContactInput.vue'
    )
);
Vue.component(
    'fieldBedingungeninput',
    () => import(
        /* webpackChunkName: "bedingungen-input" */
        './components/kundenantrag/BedingungenInput.vue'
    )
);
Vue.component(
    'fieldSubmitinput',
    () => import(
        /* webpackChunkName: "submit-input" */
        './components/kundenantrag/SubmitInput.vue'
    )
);
Vue.component(
    'fieldCityinput',
    () => import(
        /* webpackChunkName: "city-input" */
        './components/kundenantrag/CityInput.vue'
    )
);
Vue.component(
    'fieldTextmessage',
    () => import(
        /* webpackChunkName: "text-message" */
        './components/kundenantrag/TextMessage.vue'
    )
);
Vue.component(
    'antrag-component',
    () =>  import(
        /* webpackChunkName: "antrag-component" */
        './components/kundenantrag/AntragComponent.vue'
    )
);

Vue.component(
    'sync-loader',
    require('./components/vue-spinner/src/SyncLoader.vue').default
);

const app = new Vue({
    el: '#app',
});
